function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MAX_COUNT, COLOR_PROP_TYPE, ICON_PROP_TYPE, POSITION_RIGHT, POSITION_PROP_TYPE } from './constants';
import { getCount } from './utils';
import Icon from '../icon/Icon';

var getContent = function getContent(_ref) {
  var count = _ref.count,
      contentColor = _ref.contentColor,
      iconType = _ref.iconType,
      text = _ref.text;
  var content = null;

  if (count) {
    content = getCount(count, MAX_COUNT);
  }

  if (iconType) {
    var iconColor = contentColor || 'white';
    content = React.createElement(Icon, {
      type: iconType,
      size: "xsmall",
      color: iconColor
    });
  } // Text takes precedence over icon or count


  if (text) {
    content = text;
  }

  return content;
};
/**
 * Helper component that conditionally renders the badge with a number string
 */


var BadgeContent = function BadgeContent(_ref2) {
  var _classNames;

  var bgColor = _ref2.bgColor,
      children = _ref2.children,
      contentColor = _ref2.contentColor,
      count = _ref2.count,
      iconType = _ref2.iconType,
      text = _ref2.text,
      position = _ref2.position;
  var component = null;
  var className = classNames('eds-badge__content', 'eds-fx--pop', (_classNames = {
    'eds-badge__content--round': count >= 0 && count < 10 || iconType || text && text.length === 1,
    'eds-badge__content--plus': count > MAX_COUNT,
    'eds-badge__content--count': count,
    'eds-badge__content--text': text,
    'eds-badge__content--icon': iconType,
    'eds-badge__content--standalone': !iconType && !text && !count,
    'eds-badge__content--over-children': children
  }, _defineProperty(_classNames, "eds-badge__content--over-children-".concat(position), position && children), _defineProperty(_classNames, "eds-bg-color--".concat(bgColor), bgColor), _defineProperty(_classNames, "eds-text-color--".concat(contentColor), contentColor), _classNames)); // Don't show the badge if count is set to 0

  if (count === 0) {
    return component;
  }

  var content = getContent({
    count: count,
    contentColor: contentColor,
    iconType: iconType,
    text: text
  });
  component = React.createElement("div", {
    className: className,
    "data-spec": "eds-badge__content"
  }, content);
  return component;
};

var Badge =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Badge, _PureComponent);

  function Badge() {
    _classCallCheck(this, Badge);

    return _possibleConstructorReturn(this, _getPrototypeOf(Badge).apply(this, arguments));
  }

  _createClass(Badge, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement("div", {
        className: "eds-badge",
        "data-spec": "eds-badge"
      }, children, React.createElement(BadgeContent, this.props));
    }
  }]);

  return Badge;
}(PureComponent);

_defineProperty(Badge, "propTypes", {
  /**
   * The background color of the Badge
   */
  bgColor: COLOR_PROP_TYPE,

  /**
   * The object over which the Badge is placed (e.g. Icon or Text)
  */
  children: PropTypes.node,

  /**
   * The fill color of the text or icon in the Badge
  */
  contentColor: COLOR_PROP_TYPE,

  /**
   * Numerical content of the Badge.
   * Differs from text as it will disappear when count is 0
   * and it will truncate to 99+ when count is > 100
  */
  count: PropTypes.number,

  /**
   * Icon content of the Badge
   */
  iconType: ICON_PROP_TYPE,

  /**
   * Textual content of the Badge
   */
  text: PropTypes.string,

  /**
   * Position in relation to child node
   */
  position: POSITION_PROP_TYPE
});

_defineProperty(Badge, "defaultProps", {
  position: POSITION_RIGHT
});

export { Badge as default };